<template>
    <v-combobox :model-value="modelValue" @update:model-value="input" variant="outlined" density="compact"
        :items="known_superprojects" no-data-text="No superproject" clearable class="mx-1" label="Super project"
        hint="Only if belongs to a group of projects"></v-combobox>
</template>

<script>
import { useCompanyStore } from '@/stores/company';
import { mapState } from 'pinia';

export default {
    props: ["modelValue"],
    computed: {
        ...mapState(useCompanyStore, ["projects"]),
        known_superprojects() {
            return [...new Set(
                this.projects
                    .map((p) => p.super_project)
                    .filter((sp) => sp !== "")
            )]
        },
    },
    methods: {
        input(v) {
            if (v) this.$emit("update:modelValue", v);
            else this.$emit("update:modelValue", "");
        },
    },
};
</script>